<template>
  <div class="wrapper">
    <div class="inner">
      <img src="@/assets/warn-tip-red.png" class="tip-red" alt />
      <p class="text">{{content}}</p>
      <img src="@/assets/warn-tip-close.png" class="tip-close" v-if="closable" alt />
    </div>
  </div>
</template>
<script>
import { mFetch } from '@/base/mFetch';
import JS from '@/base/JSTool';
import CommonData from '@/base/CommonData';

export default {
  name: 'WarningeTip',
  props: {
    closable: {
      type: Boolean,
    },
    content: {
      type: String,
      default: '',
    },
  },
  watch: {},
  data() {
    return {
      list: [],
      fundCode: '',
      fundType: '',
    };
  },
  created() {
    this.fundCode = CommonData.fundCode;
    this.fundType = CommonData.fundType;
    this.handleDefault();
    this.render();
  },
  mounted() {},
  methods: {
    render() {
      // #if EXECUTION_ENV == 'fund'
      this.request();
      // #endif
    },
    request() {
      // https://fundcfhapi.1234567.com.cn/cfhapp/cfhdata/H5/FundNotice?FCODE=000001&ShowPosition=1&IsAppLink=2&SaleType=1&deviceid=123&version=6.0.0&appVersion=6.0.0&product=EFund&plat=Iphone
      const url = 'https://fundcfhapi.1234567.com.cn/cfhapp/cfhdata/H5/FundNotice';
      const params = {
        FCODE: this.fundCode,
        ShowPosition: 1,
        IsAppLink: 2,
        SaleType: 1,
      };
      mFetch(url, {}, params).then((res) => {
        this.handle(res.data);
      });
    },
    handle(data) {
      // eslint-disable-next-line no-unused-vars
      const mudules = JS.fetchArray(JS.fetchJson(data, 'Datas'), 'Modules');
      // eslint-disable-next-line no-undef
      const findRes = modules.find(
        (el) => JS.fetchNumber(el, 'ModuldType') === 1216,
      );
      if (!findRes) return;
      const items = JS.fetchArray(findRes, 'Items');

      const resArr = [];
      items.forEach((el) => {
        resArr.push(this.format(el));
      });
      this.list = resArr;
    },
    format(item) {
      return {
        link: JS.fetchJson(item, 'Link'),
        title: (() => {
          const title = JS.fetchString(item, 'readTitle');
          return title || '-----';
        })(),
      };
    },
    handleDefault() {
      this.list = [this.format(null)];
    },
    clickSingle() {
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  background: #fff7bc;
  padding-left: 24px;
}
.inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 10px 10px 10px;
}

.text {
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff4400;
  line-height: 42px;
  padding: 10px 0;
  text-align: left;
}

.tip-red {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  align-self: flex-start;
  padding: 17px 0px;
}

.tip-close {
  width: 25px;
  height: 25px;
  margin-right: 30px;
  align-self: flex-start;
  padding: 15px 0px;
}
</style>
